import { applyCustomCss } from './branding'
import { getCSRFToken } from './csrf'



const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api/v1';


// const BRANDING_API_URL =
//   process.env.REACT_APP_BRANDING_API_URL || 'http://localhost:8000/api/branding';


async function _check(res, errMsg) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || errMsg);
  return data;
}

export async function fetchFaqs({ search = '', language = '', country = '', category = '' }) {
  const params = new URLSearchParams();
  if (search)   params.append('search', search);
  if (language) params.append('language', language);
  if (country)  params.append('country', country);
  if (category) params.append('category', category);

  const res = await fetch(`${BASE_URL}/faq_entries?${params}`, {
    method:      'GET',
    credentials: 'include',
    headers:     { 'Accept': 'application/json' },
  });
  if (!res.ok) throw new Error('Failed to fetch FAQ entries');
  return res.json();
}

export async function createFaq(faqData) {
  const csrfToken = getCSRFToken()
  const res = await fetch(`${BASE_URL}/faq_entries`, {
    method:      'POST',
    credentials: 'include',
    headers:     {
      'Content-Type':  'application/json',
      'Accept':        'application/json',
      'X-CSRF-Token':  csrfToken
    },
    body: JSON.stringify({ faq_entry: faqData }),
  })
  return _check(res, 'Failed to create FAQ entry')
}


export async function deleteFaq(faqId) {
  const csrfToken = getCSRFToken()
  const res = await fetch(`${BASE_URL}/faq_entries/${faqId}`, {
    method:      'DELETE',
    credentials: 'include',
    headers:     {
      'Accept':       'application/json',
      'X-CSRF-Token': csrfToken
    },
  })
  return _check(res, 'Failed to delete FAQ entry')
}


export async function updateFaq(faqId, updatedData) {
  const csrfToken = getCSRFToken()
  const res = await fetch(`${BASE_URL}/faq_entries/${faqId}`, {
    method:      'PATCH',
    credentials: 'include',
    headers:     {
      'Content-Type':  'application/json',
      'Accept':        'application/json',
      'X-CSRF-Token':  csrfToken
    },
    body: JSON.stringify({ faq_entry: updatedData }),
  })
  return _check(res, 'Failed to update FAQ entry')
}


export async function createFeedback(faqEntryId, { rating, comment }) {
  const payload = { feedback: { rating } }
  if (comment != null && comment.trim() !== '') {
    payload.feedback.comment = comment
  }
  const csrfToken = getCSRFToken()
  const res = await fetch(
    `${BASE_URL}/faq_entries/${faqEntryId}/feedbacks`,
    {
      method:      'POST',
      credentials: 'include',
      headers:     {
        'Content-Type':  'application/json',
        'X-CSRF-Token':  csrfToken
      },
      body: JSON.stringify(payload),
    }
  )
  return _check(res, 'Failed to submit feedback')
}



export async function fetchFeedbacks(faqEntryId) {
  const res = await fetch(
    `${BASE_URL}/faq_entries/${faqEntryId}/feedbacks`,
    {
      method:      'GET',
      credentials: 'include',
      headers:     { 'Accept': 'application/json' },
    }
  );
  if (!res.ok) throw new Error('Failed to load feedbacks');
  return res.json();
}


export async function deleteFeedback(faqEntryId, feedbackId) {
  const csrfToken = getCSRFToken()
  const res = await fetch(
    `${BASE_URL}/faq_entries/${faqEntryId}/feedbacks/${feedbackId}`,
    {
      method:      'DELETE',
      credentials: 'include',
      headers:     {
        'Accept':       'application/json',
        'X-CSRF-Token': csrfToken
      },
    }
  )
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error(err.error || 'Failed to delete feedback')
  }
  return
}



export async function fetchFaqDetail(faqId) {
  const res = await fetch(`${BASE_URL}/faq_entries/${faqId}`, {
    credentials: 'include',
    headers:     { 'Accept': 'application/json' },
  });
  if (!res.ok) throw new Error('Failed to fetch FAQ details');
  return res.json();
}

export async function createUser(userData) {
  const csrfToken = getCSRFToken()
  const res = await fetch(`${BASE_URL}/users`, {
    method:      'POST',
    credentials: 'include',
    headers:     {
      'Content-Type':  'application/json',
      'Accept':        'application/json',
      'X-CSRF-Token':  csrfToken
    },
    body: JSON.stringify({ user: userData }),
  })
  return _check(res, 'Failed to create user')
}

export async function deleteUser(userId) {
  const csrfToken = getCSRFToken();
  const res = await fetch(`${BASE_URL}/users/${userId}`, {
    method:      'DELETE',
    credentials: 'include',
    headers:     {
      'X-CSRF-Token':  csrfToken,
      'Accept':        'application/json',
    },
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to delete user');
  }
}

export async function getCurrentUser() {
  const res = await fetch(`${BASE_URL}/current_user`, {
    method:      'GET',
    credentials: 'include',
    headers:     { 'Accept': 'application/json' },
  });
  if (!res.ok) throw new Error('Not logged in');
  const { user } = await res.json();
  return user;
}

export async function loginUser({ email, password }) {
  const csrfToken = getCSRFToken()
  const res = await fetch(`${BASE_URL}/login`, {
    method:      'POST',
    credentials: 'include',
    headers:     {
      'Content-Type':  'application/json',
      'Accept':        'application/json',
      'X-CSRF-Token':  csrfToken
    },
    body: JSON.stringify({ email, password }),
  })

  const payload = await res.json().catch(() => ({}))
  if (!res.ok) {
    throw new Error(payload.error || 'Login failed')
  }

  const { user, jwt } = payload;
  if (jwt) window.localStorage.setItem('faqhelps_jwt', jwt);
  return user;
}



export async function logoutUser() {
  const csrfToken = getCSRFToken()
  const res = await fetch(`${BASE_URL}/logout`, {
    method:      'DELETE',
    credentials: 'include',
    headers:     { 'X-CSRF-Token': csrfToken }
  })
  if (!res.ok) throw new Error('Logout failed')

  // reset branding immediately after a successful logout
  applyCustomCss('')
}



export async function fetchAdminStats(search = '') {
  const params = new URLSearchParams()
  if (search) params.append('search', search)
  const url = `${BASE_URL}/admin/dashboard${params.toString() ? `?${params}` : ''}`
  const res = await fetch(url, {
    method:      'GET',
    credentials: 'include',
    headers:     { 'Accept': 'application/json' },
  })
  return _check(res, 'Failed to load admin dashboard')
}


export async function uploadCsv(formData, override = false, decisions = null) {
  formData.set('override', override ? 'true' : 'false')

  if (override && decisions) {
    formData.set('decisions', JSON.stringify(decisions))
  }

  const csrfToken = getCSRFToken()
  const res = await fetch(`${BASE_URL}/admin/uploads`, {
    method:      'POST',
    credentials: 'include',
    headers:     { 'X-CSRF-Token': csrfToken },
    body:        formData,
  })
  const data = await res.json().catch(() => ({}))

  if (res.status === 409) {
    return data
  }
  if (!res.ok) {
    throw new Error(data.error || 'Upload failed')
  }
  return data
}


export async function fetchCompanySetting() {
  const res = await fetch(`${BASE_URL}/company_setting`, {
    method:      'GET',
    credentials: 'include',
    headers:     { 'Accept': 'application/json' },
  });
  return _check(res, 'Failed to fetch company settings');
}

export async function updateCompanySetting(settingsData) {
  const isForm = settingsData instanceof FormData;
  const csrfToken = getCSRFToken()
  const res = await fetch(`${BASE_URL}/company_setting`, {
    method:      'PATCH',
    credentials: 'include',
    headers:     isForm
      ? {
          'Accept':       'application/json',
          'X-CSRF-Token': csrfToken
        }
      : {
          'Content-Type':  'application/json',
          'Accept':        'application/json',
          'X-CSRF-Token':  csrfToken
        },
    body: isForm
      ? settingsData
      : JSON.stringify({ company_setting: settingsData }),
  })
  const data = await _check(res, 'Failed to update company settings');
  return data.company_setting ?? data;
}


export async function useFaq(faqId) {
  const csrfToken = getCSRFToken()
  const res = await fetch(`${BASE_URL}/faq_entries/${faqId}/use`, {
    method:      'POST',
    credentials: 'include',
    headers:     {
      'Accept':        'application/json',
      'X-CSRF-Token':  csrfToken
    },
  })
  return _check(res, 'Failed to record usage')
}


export async function fetchFilters() {
  const res = await fetch(`${BASE_URL}/filters`, {
    credentials: 'include',
    headers:     { 'Accept': 'application/json' },
  });
  if (!res.ok) throw new Error('Failed to load filter options');
  return res.json();
}

export async function fetchPinnedFaqs() {
  const res = await fetch(`${BASE_URL}/pinned_faqs`, {
    credentials: 'include',
    headers:     { 'Accept': 'application/json' },
  });
  return _check(res, 'Failed to load pinned FAQs');
}

export async function pinFaq(faqEntryId) {
  const csrfToken = getCSRFToken()
  const res = await fetch(`${BASE_URL}/pinned_faqs`, {
    method:      'POST',
    credentials: 'include',
    headers:     {
      'Content-Type':  'application/json',
      'Accept':        'application/json',
      'X-CSRF-Token':  csrfToken
    },
    body: JSON.stringify({ faq_entry_id: faqEntryId }),
  })
  return _check(res, 'Failed to pin FAQ')
}


export async function updatePinnedFaq(pinId, position) {
  const csrfToken = getCSRFToken()
  const res = await fetch(`${BASE_URL}/pinned_faqs/${pinId}`, {
    method:      'PATCH',
    credentials: 'include',
    headers:     {
      'Content-Type':  'application/json',
      'Accept':        'application/json',
      'X-CSRF-Token':  csrfToken
    },
    body: JSON.stringify({ position }),
  })
  if (!res.ok) throw new Error('Failed to reorder pinned FAQ')
}


export async function unpinFaq(pinId) {
  const csrfToken = getCSRFToken()
  const res = await fetch(`${BASE_URL}/pinned_faqs/${pinId}`, {
    method:      'DELETE',
    credentials: 'include',
    headers:     { 'X-CSRF-Token': csrfToken }
  })
  if (!res.ok) throw new Error('Failed to unpin FAQ')
}


export async function fetchAdminUsers() {
  const res = await fetch(`${BASE_URL}/admin/users`, {
    credentials: 'include',
    headers:     { 'Accept': 'application/json' },
  })
  if (!res.ok) throw new Error('Failed to load users')
  const payload = await res.json()
  return payload.users ?? payload
}

export async function updateAdminUser(userId, attrs) {
  const csrfToken = getCSRFToken()
  const res = await fetch(`${BASE_URL}/admin/users/${userId}`, {
    method:      'PATCH',
    credentials: 'include',
    headers:     {
      'Content-Type':  'application/json',
      'Accept':        'application/json',
      'X-CSRF-Token':  csrfToken
    },
    body: JSON.stringify({ user: attrs }),
  })
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error(err.error || 'Failed to update user')
  }
  const { user } = await res.json()
  return user
}


export async function sendPasswordReset(email) {
  const csrfToken = getCSRFToken()
  const res = await fetch(`${BASE_URL}/password_resets`, {
    method:      'POST',
    credentials: 'include',
    headers:     {
      'Content-Type':  'application/json',
      'X-CSRF-Token':  csrfToken
    },
    body: JSON.stringify({ email }),
  })
  return _check(res, 'Failed to send reset link')
}



export async function resetPassword({ token, password, password_confirmation }) {
  const csrfToken = getCSRFToken()
  const res = await fetch(
    `${BASE_URL}/password_resets/${encodeURIComponent(token)}`,
    {
      method:      'PATCH',
      credentials: 'include',
      headers:     {
        'Content-Type':  'application/json',
        'X-CSRF-Token':  csrfToken
      },
      body: JSON.stringify({ password, password_confirmation })
    }
  )

  const payload = await res.json().catch(() => ({}))
  if (!res.ok) {
    throw new Error(payload.error || res.statusText)
  }
  return payload
}


// export async function scrapeBaseline(url) {
//   const res = await fetch(`${BRANDING_API_URL}/scrape-baseline`, {
//     method:      'POST',
//     credentials: 'include',
//     headers:     {
//       'Content-Type': 'application/json',
//       'Accept':       'application/json',
//     },
//     body: JSON.stringify({ url })
//   });
//   return _check(res, 'Failed to scrape baseline CSS');
// }

export async function fetchBrandingTemplates() {
  const resp = await fetch(`${BASE_URL}/branding_templates`, {
    credentials: 'include',
    headers: { 'Accept': 'application/json', 
    }
  })
  if (!resp.ok) throw new Error(`Unable to fetch templates: ${resp.statusText}`)
  return resp.json()
}

export async function fetchBrandingTemplate(id) {
  const resp = await fetch(`${BASE_URL}/branding_templates/${id}`, {
    credentials: 'include',
    headers: { 'Accept': 'application/json',
    }
  })
  if (!resp.ok) throw new Error(`Unable to fetch template ${id}: ${resp.statusText}`)
  return resp.json()
}

export async function saveBrandingTemplate(formData) {
  const maybeId = formData.get('template[id]')
  let url = `${BASE_URL}/branding_templates`
  let method = 'POST'

  if (maybeId) {
    url = `${BASE_URL}/branding_templates/${maybeId}`
    method = 'PUT'
    formData.delete('template[id]')
  }

  const csrfToken = getCSRFToken()
  const resp = await fetch(url, {
    method,
    credentials: 'include',
    headers:     {
      'X-CSRF-Token': csrfToken
    },
    body: formData
  })

  if (!resp.ok) {
    const json = await resp.json().catch(() => null)
    const errMsg = (json && json.errors) ? json.errors.join('; ') : resp.statusText
    throw new Error(`Could not save template: ${errMsg}`)
  }
  return resp.json()
}

